import { ALL_DATA_TYPES } from './dataTypes';

export const TASK_STATUSES = [{
  value: 'pending',
  label: 'Pending',
}, {
  value: 'completed',
  label: 'Completed',
}, {
  value: 'overdue',
  label: 'Overdue',
}, {
  value: 'cancelled',
  label: 'Cancelled',
}, {
  value: 'archived',
  label: 'Archived',
}];

export const TASK_TYPE_CONDITION_KEY = {
  key: 'owner',
  value: 'Owner',
  dataType: ALL_DATA_TYPES.reference_user,
};

export const TASK_STATUS_CONDITION_KEY = {
  key: 'status',
  value: 'Status',
  dataType: ALL_DATA_TYPES.dropdown,
  children: TASK_STATUSES,
};

export const TASK_START_TIME_CONDITION_KEY = {
  key: 'start_time',
  value: 'Start Time',
  dataType: ALL_DATA_TYPES.date,
};

export const TASK_END_TIME_CONDITION_KEY = {
  key: 'end_time',
  value: 'End Time',
  dataType: ALL_DATA_TYPES.date,
};

export const TASK_TYPE_OPTIONS = [
  TASK_TYPE_CONDITION_KEY,
  TASK_STATUS_CONDITION_KEY,
  TASK_START_TIME_CONDITION_KEY,
  TASK_END_TIME_CONDITION_KEY,
];
